/** Shared by both /mobile-settings tabs: scroll to the Guest App Preview block and focus it. */
export const focusPreviewSection = (section: HTMLElement | null) => {
  if (!section) return;
  section.scrollIntoView({ behavior: "smooth", block: "center" });
  section.focus({ preventScroll: true });
};
